import Breadcrumbs from '@mui/material/Breadcrumbs'
import { Box } from '@mui/system'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

export default function CustomizedBreadcrumbs({ breadcrumbs }: any) {
  return (
    <Box role="presentation" sx={{ mt: { xs: '24%', sm: '10px' } }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          display: { xs: 'none', md: 'block' },
          padding: { xs: 0, sm: '10px 0' },
          fontSize: '14px'
        }}
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Box>
  )
}
